module.exports = __webpack_public_path__ + "static/book_of_exalted_deeds-f9e17132f0dd386e394e78a77728633c.jpeg";